module.exports = __webpack_public_path__ + "static/img/video.0ec9649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrCode/video.png
// module id = E3F8
// module chunks = 12